import { InputAdornment, TextField, Typography } from '@mui/material';
import React from 'react';

export const TextLength = React.forwardRef(
  (
    { label, endAdornment, maxLength = 140, readOnly = false, ...props },
    ref
  ) => (
    <TextField
      label={label}
      variant="outlined"
      size="small"
      maxLength={9}
      sx={{
        '& .MuiInputBase-root': {
          paddingRight: '8px',
        },
      }}
      InputProps={{
        maxLength: 9,
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{
              alignItems: 'end',
            }}>
            <Typography
              sx={{
                fontSize: '10px',
              }}>
              {endAdornment}
            </Typography>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        readOnly,
        maxLength,
        ref,
      }}
      {...props}
    />
  )
);

TextLength.displayName = 'TextLength';
